import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader } from '../Modal';
import { isEmpty } from '../../utils/lodashExtend';
import { TAXPAYER_EXPIRED_TYPE } from '../../constants/TaxPortal/MANAGEMENT_CONTACT_TYPE';
import Form from '../Form';
import useForm from '../../hooks/useForm';
import { getDay } from '../../utils/date';
import systemAlert from '../../utils/systemAlert';
import { toast } from '../../utils/toast';
import { taxpayerFired } from '../../apis/tax-portal/taxpayer';

const defaultForm = {
  expiredDate: getDay(),
  expiredType: TAXPAYER_EXPIRED_TYPE[0].label
};
const CustodianExpiredModal = ({ open, setOpen, taxpayerList, setTaxpayerList, submit }) => {

  const cancel = (e) => {

    if (e) {
      e.preventDefault();
    }
    resetForm(defaultForm);
    setOpen(false);
    setTaxpayerList && setTaxpayerList([]);
  };

  const [fields, setFields] = useState([]);

  const _submit = (form) => {
    const params = {
      expiredDate: form.expiredDate[0],
      expiredType: form.expiredType,
      idxes: taxpayerList.map(item => item.idx),
      reason: form.reason,
    };

    systemAlert(
      `수임처 "${taxpayerList[0].companyName}"${taxpayerList.length === 1 ? "" : ` 외 ${taxpayerList.length - 1}개`} 의 해임일을 지정하시겠습니까?`,
      {
        buttons: [{ label: "취소", color: "text" },
        {
          label: "해임일 변경", onClick: () => {

            taxpayerFired(params)
              .then(() => {
                toast.success("변경이 완료되었습니다.");
                submit && submit();
                cancel();
              });
          }
        }
        ]
      }
    );
  };

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    resetForm,
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    const _fields = [
      [
        {
          title: (
            <>
              <span >해임일자</span>
            </>
          ),
          key: "expiredDate",
          type: "datepicker",
          onChanged: ({ form, onChange }) => {
            !isEmpty(form?.expiredDate)
              && onChange({ expiredType: "close" });
          }
        },
      ],
      [
        {
          title: "해임사유",
          key: "expiredType",
          type: "radio",
          options: { list: TAXPAYER_EXPIRED_TYPE },
        },
      ],
      [
        {
          title: "해임 사유(기타) 입력",
          key: "reason",
          type: "input",
          isHide: () => form.expiredType !== "etc",
          placeholder: "해임사유 입력"
        },
      ],
    ];

    setFields(_fields);
  }, [form]);


  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
        size="md"
      >
        <ModalHeader>해임일 설정</ModalHeader>
        <Form
          mode={"modify"}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          cancelText={'닫기'}
          submitText={"해임일 변경"}
          submit={handleSubmit}
          cancel={cancel}
        />
      </Modal>
    </>
  );
};

export default CustodianExpiredModal;